<div class="search-bar-cont"
  *ngIf="showHeaderMobile"
  [class.results]="isResultPage"
  [class.alert]="isAlert">
  <ng-container *ngIf="isMobile; else searchBarDesktop">
    <ng-container *ngIf="!isResultPage;">
      <ng-container *ngTemplateOutlet="searchBarMobile"></ng-container>
    </ng-container>
  </ng-container>
</div>
<app-swipe-up
  *ngIf="isResultPage"
  [classType]="swipeStyle"
  [height]="100"
  [title]="'TITLE_SEARCH_HOME' | transloco"
  [showSwipeUp]="editSearchIsActivated$ | async"
  [showHeader]="true"
  (toggleShowSwipeUp)="toggleSearchModule()">
  <ng-container *ngIf="editSearchIsActivated$ | async" content>
    <ng-container *ngTemplateOutlet="searchBarMobile"></ng-container>
  </ng-container>
</app-swipe-up>

<ng-template #searchBarMobile>
  <app-search-bar-mobile
    [destination]="destination"
    [source]="source"
    [searchType]="searchType"
    [currentUrl]="currentUrl"
    [searchData]="searchData$ | async"
    [airports]="airports"
    [defaultPlace]="defaultPlace"
    [isExchangeSearch]="exchangeSearch"
    [exchangeTripType]="exchangeTripType"
    [departureDateIsDisabled]="departureDateIsDisabled"
    [routeChangeIsDisabled]="!!exchangeData?.RouteChangeIsDisabled"
    [validate]="validate"
    [baggageIncluded]="baggageIncluded$ | async"
    (swapLocationsEmitter)="swapPlaces()"
    (emitArrangement)="setPassengerArrangement($event)"
    (emitFlightClassSelection)="setFlightClass($event)"
    (selectBusType)="selectFlightType($event)"
    (selectFlightType)="selectFlightType($event)"
    (selectPlace)="selectPlace($event)"
    (emitSearch)="search()"
    (toggleSearchByFlexDates)="toggleSearchByFlexDates($event)"
    (showMobileCalendarEvent)="showMobileCalendar($event)"
    (placeInputChanged)="placeInputChanged($event)"
    (selectCalendar)="selectCalendar($event)"
    (selectedBaggageIncluded)="includeBaggage($event)"
    (removeAutoCompletePlaces)="clearAutocompletePlaces()"
    (amplitudeEvent)="amplitudeEvent($event)"
    (toggleEvent)="toggleMobileSearch()">
  </app-search-bar-mobile>
</ng-template>

<ng-template #searchBarDesktop>
  <app-search-bar-desktop
    [destination]="destination"
    [searchType]="searchType"
    [departurePlace]="departurePlace$ | async"
    [arrivalPlace]="arrivalPlace$ | async"
    [departureDate]="departureDate$ | async"
    [arrivalDate]="arrivalDate$ | async"
    [defaultPlace]="defaultPlace"
    [flightType]="flightType$ | async"
    [isLoadingAutocompletePlaces]="isLoadingAutocompletePlaces$ | async"
    [activeFlightClass]="flightClass$ | async"
    [passengerArrangement]="filterPassengerArrangement(passengerArrangement$ | async)"
    [autoCompletePlaces]="autoCompletePlaces$ | async | autocompleteVm"
    [airports]="airports"
    [baggageIncluded]="baggageIncluded$ | async"
    (swapLocationsEmitter)="swapPlaces()"
    (emitArrangement)="setPassengerArrangement($event)"
    (emitFlightClassSelection)="setFlightClass($event)"
    (selectFlightType)="selectFlightType($event)"
    (selectPlace)="selectPlace($event)"
    (emitSearch)="search()"
    (placeInputChanged)="placeInputChanged($event)"
    (selectFlightCalendar)="selectDateCalendar($event)"
    (selectedBaggageIncluded)="includeBaggage($event)"
    (removeAutoCompletePlaces)="clearAutocompletePlaces()"
    (amplitudeEvent)="amplitudeEvent($event)">
  </app-search-bar-desktop>
</ng-template>
